var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconetinder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 55.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffab8a;}.cls-2{fill:#dc8470;}.cls-24,.cls-3{fill:#fff;}.cls-4{fill:#6d3300;}.cls-12,.cls-13,.cls-14,.cls-23,.cls-24,.cls-29,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_30);stroke:url(#D\xE9grad\xE9_sans_nom_50);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_30-2);stroke:url(#D\xE9grad\xE9_sans_nom_50-2);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_30-3);stroke:url(#D\xE9grad\xE9_sans_nom_50-3);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_33);}.cls-9{fill:#e5e5e5;}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_33-2);}.cls-11{fill:#28406b;}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_33-3);stroke:url(#D\xE9grad\xE9_sans_nom_33-4);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_33-5);stroke:url(#D\xE9grad\xE9_sans_nom_33-6);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_33-7);stroke:url(#D\xE9grad\xE9_sans_nom_33-8);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_30-4);}.cls-16{opacity:0.6;}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_30-5);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_33-9);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_33-10);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_33-11);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_33-12);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_33-13);}.cls-23,.cls-29{stroke:#17243f;}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_30-6);}.cls-24{stroke:url(#D\xE9grad\xE9_sans_nom_30-7);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_30-8);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_33-14);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_30-9);}.cls-28{fill:#17243f;}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_30-10);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_33-15);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_33-16);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    x1: 17.65,
    y1: 45.66,
    x2: 43.84,
    y2: 45.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50",
    x1: 17.15,
    y1: 45.59,
    x2: 44.34,
    y2: 45.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#19e9c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1cd5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1fc6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#21beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-2",
    x1: 37,
    y1: 46.89,
    x2: 43.84,
    y2: 46.89,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-2",
    x1: 35.9,
    y1: 46.41,
    x2: 44.34,
    y2: 46.41,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-3",
    x1: 16.46,
    y1: 46.56,
    x2: 24.01,
    y2: 46.56,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-3",
    x1: 15.96,
    y1: 46.56,
    x2: 24.51,
    y2: 46.56,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33",
    x1: 20.67,
    y1: 48.22,
    x2: 42.31,
    y2: 48.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17243e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-2",
    x1: 20.67,
    y1: 48.5,
    x2: 41.65,
    y2: 48.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-3",
    x1: 125.36,
    y1: 498.85,
    x2: 128.71,
    y2: 498.85,
    gradientTransform: "translate(-412.92 -249.05) rotate(-45)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-4",
    x1: 124.86,
    y1: 498.85,
    x2: 129.21,
    y2: 498.85,
    gradientTransform: "translate(-412.92 -249.05) rotate(-45)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-5",
    x1: 124.87,
    y1: 499.23,
    x2: 128.5,
    y2: 499.23,
    gradientTransform: "translate(-412.92 -249.05) rotate(-45)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-6",
    x1: 124.37,
    y1: 499.3,
    x2: 128.85,
    y2: 499.3,
    gradientTransform: "translate(-412.92 -249.05) rotate(-45)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-7",
    x1: 126,
    y1: 498.85,
    x2: 128.07,
    y2: 498.85,
    gradientTransform: "translate(-412.92 -249.05) rotate(-45)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-8",
    x1: 125.5,
    y1: 498.85,
    x2: 128.57,
    y2: 498.85,
    gradientTransform: "translate(-412.92 -249.05) rotate(-45)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-4",
    x1: 24.89,
    y1: 8.68,
    x2: 34.18,
    y2: 8.68,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-5",
    x1: 30.33,
    y1: 6.52,
    x2: 34.18,
    y2: 6.52,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-9",
    x1: 29.43,
    y1: 1.17,
    x2: 29.65,
    y2: 1.17,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-10",
    x1: 32.42,
    y1: 2.1,
    x2: 33.75,
    y2: 2.1,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-11",
    x1: 34.25,
    y1: 4.64,
    x2: 36.38,
    y2: 4.64,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-12",
    x1: 25.25,
    y1: 2.1,
    x2: 26.58,
    y2: 2.1,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-13",
    x1: 22.67,
    y1: 4.64,
    x2: 24.81,
    y2: 4.64,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-6",
    x1: 0.5,
    y1: 9.3,
    x2: 15.27,
    y2: 9.3,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-7",
    x1: 1.87,
    y1: 8.64,
    x2: 13.29,
    y2: 8.64,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-8",
    x1: 4.91,
    y1: 8.8,
    x2: 10.29,
    y2: 8.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-14",
    x1: 4.92,
    y1: 8.49,
    x2: 10.2,
    y2: 8.49,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-9",
    x1: 4.87,
    y1: 8.49,
    x2: 10.25,
    y2: 8.49,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-10",
    x1: 45.25,
    y1: 20.31,
    x2: 60.5,
    y2: 20.31,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-15",
    x1: 48.85,
    y1: 20.61,
    x2: 56.64,
    y2: 20.61,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-16",
    x1: 48.79,
    y1: 20.62,
    x2: 56.7,
    y2: 20.62,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.53,36.79l-.1.81-.14,1.09h0l-2.8.34h-.09l0-.11-.25-.67s0-.1,0-.14a9.79,9.79,0,0,1-.56-3.07V34.8h0a.4.4,0,0,1,.35-.47,1.05,1.05,0,0,1,.31,0l.12,0,.08,0s0,0,0,0a.27.27,0,0,1,.1-.11.68.68,0,0,1,.31-.11.79.79,0,0,1,.64.1h0a.29.29,0,0,1,.14-.13A1.37,1.37,0,0,1,15,34a.62.62,0,0,1,.19,0l.16.05s0,0,0,0a.72.72,0,0,0,0-.21l0-.41,0-1.16,0-.62a.36.36,0,0,1,.32-.34.35.35,0,0,1,.39.33h0l.41,3.84A5.4,5.4,0,0,1,16.53,36.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.73,24.19a16.3,16.3,0,0,0-1.34,7.74,15.81,15.81,0,0,1-.16,3.83,23,23,0,0,1-1.3,3.37,5.22,5.22,0,0,0-.35,3.51,5.31,5.31,0,0,0,2.24,2.57c1,.64,2,1.16,2.95,1.87.69.54,1.29,1.19,2,1.7A6.9,6.9,0,0,0,31.2,50.1a2,2,0,0,0,.87-.06,1.89,1.89,0,0,0,1-1.79,4.93,4.93,0,0,1,.3-2.14c.53-1,1.83-1.26,2.85-1.78a5.3,5.3,0,0,0,2.64-6.2c-.24-.76-.66-1.46-.94-2.21-.93-2.58-.33-5.39-.51-8.06-.25-3.85-3.11-7.6-7.38-7.55A7,7,0,0,0,25,22.44c-.12.11-.18.2-.2.21a9.43,9.43,0,0,0-.75,1S24,23.68,23.73,24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.29,34.79h0a.93.93,0,0,0,1.08,0h0a.93.93,0,0,1,.48-.17,3.2,3.2,0,0,0,.54-.08l.1-1.38-3.23,0,.12,1.38.44,0A.9.9,0,0,1,29.29,34.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.36,35.12l0-.58a3.2,3.2,0,0,1-.54.08.93.93,0,0,0-.48.17.93.93,0,0,1-1.08,0,.9.9,0,0,0-.47-.17l-.44,0,.06.71a1,1,0,0,1-.58,1,23.23,23.23,0,0,1-2.2.93c-1.07.35,5.4,1.87,8,0l.11-.25s-.92-.36-1.69-.68A1.14,1.14,0,0,1,31.36,35.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.22,29.67a1,1,0,0,1-.71,1.25,1.17,1.17,0,0,1-1.22-1A.85.85,0,0,1,25,28.84,1.05,1.05,0,0,1,26.22,29.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.11,29.86a.88.88,0,0,0-1-.7.72.72,0,0,0-.62.94,1,1,0,0,0,1,.82.82.82,0,0,1-.85-.67.59.59,0,0,1,.5-.78.72.72,0,0,1,.84.58.67.67,0,0,1-.45.86A.81.81,0,0,0,26.11,29.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.51,29.67a1,1,0,0,0,.7,1.25,1.17,1.17,0,0,0,1.22-1,.85.85,0,0,0-.72-1.12A1,1,0,0,0,33.51,29.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.62,29.86a.87.87,0,0,1,1-.7.71.71,0,0,1,.62.94,1,1,0,0,1-1,.82.83.83,0,0,0,.86-.67.59.59,0,0,0-.51-.78.73.73,0,0,0-.84.58.67.67,0,0,0,.46.86A.81.81,0,0,1,33.62,29.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.41,33.7h0a.92.92,0,0,1-1.07,0h0a1.07,1.07,0,0,0-.48-.17,4,4,0,0,1-3.59-4.08V28a4,4,0,0,1,3.84-4.09h1.53A4,4,0,0,1,34.48,28v1.47a4,4,0,0,1-3.59,4.08A1.07,1.07,0,0,0,30.41,33.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.4,34.25h0a1,1,0,0,1-1.08,0h0a.9.9,0,0,0-.47-.17A4,4,0,0,1,25.26,30V28.53a4,4,0,0,1,3.83-4.09h1.54a4,4,0,0,1,3.84,4.09V30a4,4,0,0,1-3.59,4.08A.93.93,0,0,0,30.4,34.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.87,29a5.93,5.93,0,0,1,.41,1.62.1.1,0,0,1-.06.1,7,7,0,0,1-.79.1s.64-.28.6-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.78,28.53a.37.37,0,0,0,0,.11.67.67,0,0,0,.09.14.78.78,0,0,0,.52.3,1.84,1.84,0,0,0,1.18-.24l.19-.08-.57-.26-.37-.2-.62,0-.47.23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 27.64,
    cy: 28.69,
    rx: 0.44,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.64,
    cy: 28.69,
    rx: 0.23,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.77,28.53a1.38,1.38,0,0,1-.39-.11l.25-.13a2.79,2.79,0,0,1,.58-.18,1.45,1.45,0,0,1,.36,0,1.88,1.88,0,0,1,.61.15,1.84,1.84,0,0,1,.43.3,1,1,0,0,1,.21.21h0a3.64,3.64,0,0,0-1.22-.44,1.64,1.64,0,0,0-.83.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.12,28.53a.37.37,0,0,1,0,.11.42.42,0,0,1-.09.14.78.78,0,0,1-.52.3,1.84,1.84,0,0,1-1.18-.24l-.19-.08.57-.26.37-.2.62,0,.47.23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 32.21,
    cy: 28.69,
    rx: 0.44,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.21,
    cy: 28.69,
    rx: 0.23,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.13,28.53a1.38,1.38,0,0,0,.39-.11l-.25-.13a2.79,2.79,0,0,0-.58-.18,1.43,1.43,0,0,0-.36,0,1.88,1.88,0,0,0-.61.15,1.84,1.84,0,0,0-.43.3,1,1,0,0,0-.21.21h0a3.71,3.71,0,0,1,1.22-.44,1.64,1.64,0,0,1,.83.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.15,26.72c-.39.28-.79.55-1.18.84-.63.47-1.34.65-1.82,1.26,0,0,0-.17,0-.25A3,3,0,0,1,25,27.9a4.26,4.26,0,0,1,.16-1.33,3.57,3.57,0,0,1,1.59-2.14,3.87,3.87,0,0,1,1-.4,5.33,5.33,0,0,1,2,0c.2,0,.43.11.45.3s-.13.25-.22.35,0,.06,0,.19-.62.7-.82.95A5.78,5.78,0,0,1,28.15,26.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.05,23.9a3.19,3.19,0,0,1,1.58,2.43,6.19,6.19,0,0,1,0,2.5s0,0,0,0a2.8,2.8,0,0,0-.38-.32c-.24-.24-.46-.5-.7-.74A15.87,15.87,0,0,0,30,25a.23.23,0,0,1-.11-.09.22.22,0,0,1,0-.16,2,2,0,0,1,.22-.77c.18-.2.66-.24.92-.29A3.31,3.31,0,0,1,33.05,23.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.19,54.81l-3.5,0-2.52,0,.47-3.1H23.13l.47,3.17c-.69,0-1.38-.24-2.08-.24-1.34,0-.33.68-.89-.92a4.52,4.52,0,0,1-.12-1.87c.12-2.06-3.43-4.33-2.78-6.3a27.34,27.34,0,0,1,1.14-3.18,9.5,9.5,0,0,1,2.85-3.65,11.55,11.55,0,0,1,3.14-1.52l2.62-.8v.19c0,.71,1.12,1.3,2.5,1.3s2.51-.59,2.51-1.3a.6.6,0,0,0-.06-.23A13.5,13.5,0,0,1,38.51,39a7.86,7.86,0,0,1,1.56,1.65A18.78,18.78,0,0,1,42,45.69c.58,1.87,1.11,3.74,1.65,5.62a5,5,0,0,1,.13.63C44,53.17,43.8,54.8,42.19,54.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.19,54.78l-5.19,0c1.13-1.33,3.69-1.26,4-3.27.67-4-1.8-10.43-2.52-12.57a7.86,7.86,0,0,1,1.56,1.65A18.78,18.78,0,0,1,42,45.68c.58,1.86,1.11,3.73,1.65,5.61a5.2,5.2,0,0,1,.13.62C44,53.15,43.8,54.77,42.19,54.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.52 49.4 39.49 51.45 37.05 50.68 38.52 49.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.12,26.37c-.38.29-.78.55-1.17.84a9.55,9.55,0,0,0-1.8,1.61,3.79,3.79,0,0,0-.19-.61,4.73,4.73,0,0,1,0-.65,4.37,4.37,0,0,1,.17-1.34,3.63,3.63,0,0,1,1.59-2.14,3.53,3.53,0,0,1,1-.39,5.33,5.33,0,0,1,2,0c.2,0,.43.12.45.3s-.13.25-.22.36.05.06,0,.18-.62.71-.82.95A5.84,5.84,0,0,1,28.12,26.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,23.56A3.41,3.41,0,0,1,34.79,26a8,8,0,0,1-.15,2.84s-.08,0-.08,0a15.46,15.46,0,0,0-4.63-4.15.24.24,0,0,1-.11-.09.25.25,0,0,1,0-.17h0a2,2,0,0,1,.22-.76,1.79,1.79,0,0,1,.92-.29A3.24,3.24,0,0,1,33,23.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.15,27.7a11.13,11.13,0,0,1,2.45-.24s-.32-.48-1.35-.39l-.79.05A1.26,1.26,0,0,0,31.15,27.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,27.72h.05a1.41,1.41,0,0,1,.35-.59l-.21,0a.78.78,0,0,0-.11.2A1.23,1.23,0,0,0,31,27.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1,27.34a.67.67,0,0,1,.12-.2c-.3,0-.43.15-.35.56a.06.06,0,0,0,.06.05l.08,0A1.59,1.59,0,0,1,31.1,27.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.58,27.7a11.22,11.22,0,0,0-2.46-.24s.32-.48,1.36-.39c.31,0,.57,0,.79.05A1.26,1.26,0,0,1,28.58,27.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.68,27.72h-.05a1.23,1.23,0,0,0-.35-.59l.21,0a.82.82,0,0,1,.12.2A1.59,1.59,0,0,1,28.68,27.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.62,27.34a1,1,0,0,0-.11-.2c.3,0,.42.15.35.56a.06.06,0,0,1-.06.05l-.09,0A1.24,1.24,0,0,0,28.62,27.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.57,54.83h0a2.85,2.85,0,0,1-3.25-2.32l-1.84-12a1.75,1.75,0,0,1,1.52-2l2.2-.31a1.69,1.69,0,0,1,1.93,1.37L24,51.7A2.77,2.77,0,0,1,21.57,54.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.13,33.3H29.8a1.56,1.56,0,0,1-1.52-1.11h0a.16.16,0,0,1,.16-.2h3a.16.16,0,0,1,.16.2h0A1.56,1.56,0,0,1,30.13,33.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.31,42.5,41.65,55H21.33l-.66-12.5a1,1,0,0,1,.13-.5,1.09,1.09,0,0,1,1-.56H41.21A1.08,1.08,0,0,1,42.31,42.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 31.69,
    cy: 48.62,
    rx: 1.3,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M41.65,54.88V55H21.33l-.66-12.5a1,1,0,0,1,.13-.5C21.74,44.36,26.56,52.47,41.65,54.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.47,35l0,.09,0,.1.05.18c0,.13,0,.25.07.38s0,.25.06.38,0,.12,0,.19,0,.12,0,.19v.19a.31.31,0,0,1,0,.1,1492656254789,1492656254789,0,0,1,0,.1.49.49,0,0,1,0,.11.32.32,0,0,1-.08.09.32.32,0,0,1-.23,0,.17.17,0,0,1-.11,0,.19.19,0,0,1-.08-.07.82.82,0,0,1-.11-.17L13,36.7l0-.09,0-.09h0a2.7,2.7,0,0,0,.17.34.57.57,0,0,0,.11.16l.07.06.09,0a.29.29,0,0,0,.18,0A.19.19,0,0,0,13.6,37a.32.32,0,0,0,0-.09,1.25,1.25,0,0,0,0-.19v-.19a6.77,6.77,0,0,0-.08-.76c0-.25-.07-.5-.11-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.46,34.87l0,.1,0,.09a1.46,1.46,0,0,1,.05.2,1.33,1.33,0,0,1,0,.19c0,.07,0,.13,0,.2s0,.27.05.4a2.81,2.81,0,0,1,0,.41v.1s0,.07,0,.1,0,.07,0,.1l0,.11a.53.53,0,0,1-.06.1.27.27,0,0,1-.1.08l-.12,0h-.12l-.11,0L14,37l-.15-.15s-.09-.1-.13-.16a.35.35,0,0,1,0-.08l-.06-.09h0a3.88,3.88,0,0,0,.26.31l.15.13a.48.48,0,0,0,.18.08.27.27,0,0,0,.2,0,.25.25,0,0,0,.12-.16l0-.09s0-.07,0-.1a.34.34,0,0,0,0-.1v-.1a4.18,4.18,0,0,0,0-.79c0-.27-.09-.53-.14-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.72,35.72a2.28,2.28,0,0,0-.11-.45c-.05-.18-.08-.36-.13-.54s0-.24-.1-.16a1.44,1.44,0,0,0-.18.54h0a2.67,2.67,0,0,0-.69,0,4.93,4.93,0,0,0,.05.54c0,.18,0,.33,0,.5a.12.12,0,0,0,0,.08s0,0,.06.06a2.06,2.06,0,0,0,.4.25.35.35,0,0,0,.14.06l.08.44.17.07c.05-.17.06-.35.11-.53s.1-.36.13-.54A.9.9,0,0,0,16.72,35.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.45,34.74l0,.1,0,.09,0,.2,0,.19,0,.2c0,.13,0,.26.05.39a2.67,2.67,0,0,1,0,.4l0,.2a.11.11,0,0,0,0,.05s0,0,0,0a.49.49,0,0,1,0,.11.47.47,0,0,1-.06.09l-.09.08-.13,0a.27.27,0,0,1-.12,0,.33.33,0,0,1-.1-.06L15,36.76a1.67,1.67,0,0,1-.12-.16c0-.06-.07-.12-.11-.17a.41.41,0,0,0-.05-.09l0-.09h0a2.27,2.27,0,0,0,.22.32,1,1,0,0,0,.13.16.46.46,0,0,0,.07.07l.08.05a.21.21,0,0,0,.19,0,.29.29,0,0,0,.13-.14l0-.09a.11.11,0,0,0,0-.05.09.09,0,0,0,0,0,.63.63,0,0,0,0-.19,4.19,4.19,0,0,0,0-.79l-.08-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.53,35.28l-.24-.09-.25,0-.13,0h-.25l-.12,0h0s0,0,0,0,0,0,0,0h0a.61.61,0,0,1,.13,0h.27l.13,0,.24.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.38,36.54a3,3,0,0,0-.38-.15l-.19-.06-.1,0h-.1a0,0,0,0,1,0,0s0,0,0,0h0l.11,0,.1,0,.19.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.18,15.94c0,.46-.69.84-1.54.84s-1.53-.38-1.53-.84V14.57h3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M29.64,16.78a2.41,2.41,0,0,1-1-.2v0c0,.3.44.54,1,.54s1-.24,1-.54v0A2.42,2.42,0,0,1,29.64,16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M29.65,15c-1.15,0-2.08-.51-2.08-1.14s.93-1.14,2.08-1.14,2.07.51,2.07,1.14S30.79,15,29.65,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M29.65,15c-1.1,0-2-.48-2.07-1.07v.63c0,.63.93,1.14,2.08,1.14s2.07-.51,2.07-1.14v-.7C31.72,14.5,30.79,15,29.65,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M29.65,14.57c-.71,0-1.29-.31-1.29-.7s.58-.71,1.29-.71,1.28.32,1.28.71S30.35,14.57,29.65,14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M34.18,7.48a4.52,4.52,0,0,1-.8,2.56,4.87,4.87,0,0,1-.4.5,4.13,4.13,0,0,0-.78,1.17,4.49,4.49,0,0,0-.39,1.34,1.61,1.61,0,0,1-1.62,1.39H28.88A1.65,1.65,0,0,1,27.8,14a1.55,1.55,0,0,1-.54-1,4.52,4.52,0,0,0-1.16-2.51,4.49,4.49,0,0,1-1.21-3.06,4.6,4.6,0,0,1,4.65-4.55,5.16,5.16,0,0,1,.79.06A4.63,4.63,0,0,1,33.1,4.57,4.43,4.43,0,0,1,34.18,7.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M33.38,10a7.32,7.32,0,0,0-3.05-7A4.63,4.63,0,0,1,33.1,4.57a4.43,4.43,0,0,1,1.08,2.91A4.52,4.52,0,0,1,33.38,10Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.93,11.27a17.69,17.69,0,0,0-.3-2.4c-.07-.4-.16-.79-.26-1.19s-.2-.76-.32-1.13a1,1,0,0,0-.83-.65.35.35,0,0,0-.28.07.27.27,0,0,0-.1.25.86.86,0,0,0,.09.27,2.25,2.25,0,0,0,.12.21,1.93,1.93,0,0,0,1.66,1,1.59,1.59,0,0,0,1.47-1.09,1.09,1.09,0,0,0,0-.26.37.37,0,0,0-.15-.27.47.47,0,0,0-.53,0,.65.65,0,0,0-.2.51,1.12,1.12,0,0,0,.14.48,1.37,1.37,0,0,0,.8.61,1.61,1.61,0,0,0,1.08-.11,1.79,1.79,0,0,0,.47-.3,1.16,1.16,0,0,0,.33-.4.5.5,0,0,0,0-.54.42.42,0,0,0-.25-.16.61.61,0,0,0-.3,0,.78.78,0,0,0-.24.16,1.12,1.12,0,0,0-.16.28,4.81,4.81,0,0,0-.16.54c-.11.4-.2.8-.28,1.21a19,19,0,0,0-.34,2.48c0,.2,0,.39,0,.59a.17.17,0,0,0,.17.16.16.16,0,0,0,.16-.16c0-.38,0-.77.08-1.16,0-.19.05-.38.07-.57s0-.1,0-.14,0,0,0,0V9.46c0-.1,0-.2,0-.29a20.06,20.06,0,0,1,.51-2.27l0-.11,0,0v0s0,0,0,0l.05-.1,0,0s0,0,0,0,0,0,.05,0h0l0,0h0l.06,0h0s0,0,0,0h.06l0,0h0v0h0s0,0,0,0v.09s0,0,0,0a.09.09,0,0,0,0,0v0l0,0h0v0l0,0,0,0,0,0v0h0L31.62,7l-.09.07,0,0h0l-.06,0-.2.12-.06,0h0s0,0,0,0l-.11,0-.24,0h-.3l-.11,0-.1,0h0s0,0,0,0l-.06,0A2,2,0,0,1,30,7.21s0,0,0,0l0,0,0,0-.08-.08,0,0h0s0,0,0,0A.47.47,0,0,1,29.79,7a.41.41,0,0,1-.05-.09s0,0,0,0,0,0,0,0,0,0,0,0l0-.1s0-.07,0,0a.11.11,0,0,1,0,0V6.51s0,0,0,0v0s0,0,0-.06v0s0,0,0,0h0l0,0v0h0s0,0,0,0,0,0,0,0h.09c-.05,0,0,0,0,0h0s0,0,0,0h0v0s0,0,0,0v0s0,0,0,0h0s0,0,0,0,0,0,0,0V6.4s0,0,0,0v0a1.05,1.05,0,0,1-.05.19v0s0,0,0,0,0,0,0,0l-.05.1-.06.08s0,0,0,0h0l0,0-.15.15,0,0h0l0,0-.09.06-.19.1h0l-.06,0-.1,0-.1,0H28.8a1.47,1.47,0,0,1-.21,0h-.08l-.11,0-.21-.06-.05,0h0l-.1,0a1.18,1.18,0,0,1-.19-.11l0,0h0L27.68,7l-.16-.15-.07-.08s0,0,0,0l0,0-.12-.19a.41.41,0,0,0-.05-.09.14.14,0,0,0,0-.06s0,0,0,0v0a.29.29,0,0,1,0-.1s0,0,0,0v0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h.19l.1,0,.05,0h0l0,0,0,0,0,0,0,0h0l.06.09v0s0,0,0,0a.08.08,0,0,0,0,0c0,.09.05.18.08.27l.15.54c.1.36.19.73.26,1.1s.15.74.21,1.12c0,0,0,.09,0,.13v.06s0,0,0,0v0a2.7,2.7,0,0,1,0,.28l.06.55,0,.54a.18.18,0,0,0,.17.16.16.16,0,0,0,.16-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M29.54,2.34a.11.11,0,0,1-.11-.1V.1a.11.11,0,0,1,.22,0V2.24A.11.11,0,0,1,29.54,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M32.53,3.13l-.05,0a.1.1,0,0,1,0-.14l1.1-1.85a.11.11,0,0,1,.15,0,.09.09,0,0,1,0,.14l-1.1,1.84A.11.11,0,0,1,32.53,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M34.35,5.27a.12.12,0,0,1-.09,0,.1.1,0,0,1,0-.14L36.22,4a.11.11,0,0,1,.15,0,.1.1,0,0,1,0,.14L34.41,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M26.47,3.13a.11.11,0,0,1-.1-.06l-1.1-1.84a.09.09,0,0,1,0-.14.1.1,0,0,1,.14,0L26.56,3a.1.1,0,0,1,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M24.7,5.27h-.05L22.73,4.19a.1.1,0,0,1,0-.14.11.11,0,0,1,.15,0l1.91,1.07a.09.09,0,0,1,0,.14A.11.11,0,0,1,24.7,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7.86,1.79a7.26,7.26,0,0,1,7.41,7.12,6.94,6.94,0,0,1-1.66,4.55h0l.94,3a.28.28,0,0,1-.4.33l-3-1.41h-.2a6.76,6.76,0,0,1-3.08.73A7.26,7.26,0,0,1,.5,8.91,7.27,7.27,0,0,1,7.86,1.79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 7.58,
    cy: 8.64,
    rx: 5.21,
    ry: 5.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M10.19,9.93,9,8.8l1.17-1.13a.34.34,0,0,0,0-.49l-.91-.87a.36.36,0,0,0-.51,0L7.6,7.44,6.43,6.31a.37.37,0,0,0-.51,0L5,7.18a.34.34,0,0,0,0,.49L6.18,8.8,5,9.93a.34.34,0,0,0,0,.49l.91.87a.38.38,0,0,0,.51,0L7.6,10.16l1.17,1.13a.38.38,0,0,0,.51,0l.91-.87A.34.34,0,0,0,10.19,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M5,10.07a.29.29,0,0,1,0-.42L6.22,8.49,5,7.32A.29.29,0,0,1,5,6.9L5.92,6a.31.31,0,0,1,.44,0l1.2,1.16L8.77,6a.31.31,0,0,1,.44,0l.9.87a.29.29,0,0,1,0,.42L8.91,8.49l1.2,1.16a.29.29,0,0,1,0,.42l-.9.87a.31.31,0,0,1-.44,0L7.56,9.78l-1.2,1.16a.31.31,0,0,1-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M10.08,6.94a.24.24,0,0,1,0,.35L8.83,8.49l1.25,1.19a.24.24,0,0,1,0,.35l-.91.88a.27.27,0,0,1-.36,0L7.56,9.71l-1.24,1.2a.27.27,0,0,1-.36,0L5.05,10a.24.24,0,0,1,0-.35L6.29,8.49,5.05,7.29a.24.24,0,0,1,0-.35L6,6.07a.25.25,0,0,1,.36,0L7.56,7.26,8.81,6.07a.25.25,0,0,1,.36,0l.91.87m.07-.07L9.24,6a.36.36,0,0,0-.51,0L7.56,7.12,6.39,6a.36.36,0,0,0-.51,0L5,6.87a.34.34,0,0,0,0,.49L6.15,8.49,5,9.61a.34.34,0,0,0,0,.49l.9.87a.36.36,0,0,0,.51,0L7.56,9.85,8.73,11a.37.37,0,0,0,.51,0l.91-.88a.34.34,0,0,0,0-.49L9,8.49l1.17-1.13a.34.34,0,0,0,0-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M6.24,6.27a2.72,2.72,0,0,1,.3.29c.1.12.22.23.32.35l.36.4c.09.09.22.24.36.26s.41-.24.55-.39a3.9,3.9,0,0,1,.75-.65.7.7,0,0,1,.52-.1l-.22-.22a.27.27,0,0,0-.36,0L7.57,7.41,6.33,6.21a.27.27,0,0,0-.31,0A.43.43,0,0,1,6.24,6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M10.08,9.68l-.22-.21a.59.59,0,0,1-.07.41,1.89,1.89,0,0,1-.25.31c-.09.08-.17.18-.27.26a.49.49,0,0,1-.59.08A3.63,3.63,0,0,1,8,9.84l-.33-.33a.66.66,0,0,0-.29-.17c-.28-.06-.52.27-.71.42a1.44,1.44,0,0,1-.75.42.83.83,0,0,1-.8-.52l0,0a.24.24,0,0,0,0,.35l.91.88a.27.27,0,0,0,.36,0l1.24-1.2,1.25,1.2a.27.27,0,0,0,.36,0l.91-.88A.24.24,0,0,0,10.08,9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M52.9,12.55a7.5,7.5,0,0,0-7.65,7.36A7.23,7.23,0,0,0,47,24.6h0l-1,3.09a.29.29,0,0,0,.41.34l3.13-1.46h.2a6.92,6.92,0,0,0,3.18.74,7.49,7.49,0,0,0,7.58-7.4A7.51,7.51,0,0,0,52.9,12.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.15,17.39l-.28,0a2.07,2.07,0,0,0-1.15.48,1.86,1.86,0,0,0-.45.61,2.47,2.47,0,0,0-.5-.61,2.11,2.11,0,0,0-1.16-.48h-.19a2.18,2.18,0,0,0-2.14,2.17,4,4,0,0,0,.17,1.29A4.54,4.54,0,0,0,51.21,23c.29.21.6.39.9.57a8.27,8.27,0,0,1,1,.69.12.12,0,0,0,.16,0,8.27,8.27,0,0,1,1-.69c.3-.18.61-.36.9-.57A4.54,4.54,0,0,0,57,20.86a4,4,0,0,0,.17-1.29A2.2,2.2,0,0,0,55.15,17.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M52.71,24a10.79,10.79,0,0,0-1.06-.7,8.38,8.38,0,0,1-.89-.57A4.47,4.47,0,0,1,49,20.61a4.23,4.23,0,0,1-.16-1.28,2.13,2.13,0,0,1,2-2.11,1.18,1.18,0,0,1,.26,0,2,2,0,0,1,1.13.46,1.93,1.93,0,0,1,.54.73,1.8,1.8,0,0,1,1.62-1.19,1.23,1.23,0,0,1,.27,0,2.13,2.13,0,0,1,2,2.11,4.23,4.23,0,0,1-.16,1.28,4.51,4.51,0,0,1-1.74,2.09c-.29.21-.6.4-.9.58a8.27,8.27,0,0,0-1.05.69l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M54.66,17.28a2.06,2.06,0,0,1,1.92,2,3.83,3.83,0,0,1-.16,1.26,4.38,4.38,0,0,1-1.72,2.07c-.62.46-1.35.78-2,1.27-.6-.49-1.33-.81-2-1.27a4.44,4.44,0,0,1-1.72-2.07,4.11,4.11,0,0,1-.16-1.26,2.06,2.06,0,0,1,1.93-2,1.18,1.18,0,0,1,.26,0,2,2,0,0,1,1.09.44,1.4,1.4,0,0,1,.56,1,1.86,1.86,0,0,1,.56-1,2,2,0,0,1,1.09-.44,1.1,1.1,0,0,1,.26,0m-3.82-.12a2.19,2.19,0,0,0-2.05,2.17,4.37,4.37,0,0,0,.16,1.3,4.54,4.54,0,0,0,1.77,2.12,9.67,9.67,0,0,0,.9.57,9.58,9.58,0,0,1,1.05.7l.08.06.07-.06a9,9,0,0,1,1-.69,10.61,10.61,0,0,0,.9-.58,4.54,4.54,0,0,0,1.77-2.12,4.07,4.07,0,0,0,.16-1.3,2.19,2.19,0,0,0-2-2.17l-.28,0a2,2,0,0,0-1.16.48,2.05,2.05,0,0,0-.45.61,2.27,2.27,0,0,0-.5-.61,2,2,0,0,0-1.16-.48l-.27,0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M50.88,17.77l-.06,0a1.23,1.23,0,0,0-.93.19,1.73,1.73,0,0,0-.62,1.13,2.81,2.81,0,0,0,.06,1.32,4.54,4.54,0,0,0,.35.78,3.69,3.69,0,0,1-.06-.55,2.52,2.52,0,0,1,.2-1.33,1.44,1.44,0,0,1,.7-.72c.17-.07.45-.1.58-.24S51.1,17.86,50.88,17.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M56.58,19.33a2,2,0,0,0-2.18-2,2,2,0,0,0-1.09.44,1.86,1.86,0,0,0-.56,1,1.4,1.4,0,0,0-.56-1,2,2,0,0,0-1.09-.44,1.51,1.51,0,0,0-.3,0,3.38,3.38,0,0,1,1,.78,2.75,2.75,0,0,1,.42.59,4.37,4.37,0,0,0,.35.68,8.89,8.89,0,0,0,1.08-.73,2,2,0,0,1,1.18-.31.94.94,0,0,1,.85.55A2.08,2.08,0,0,1,55.88,20a4.37,4.37,0,0,1-2.79,3.28,1.26,1.26,0,0,1-.64.11,1.86,1.86,0,0,1-.55-.22c-.4-.21-.83-.36-1.23-.57l.12.09c.63.46,1.36.78,2,1.27.6-.49,1.33-.81,2-1.27a4.38,4.38,0,0,0,1.72-2.07A3.83,3.83,0,0,0,56.58,19.33Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconetinder);
export default __webpack_public_path__ + "static/media/ICONE TINDER.bf1fb5343cd15ebbe7995664c76a0912.svg";
export { ForwardRef as ReactComponent };